import styleConfigHelper from './styleConfigHelper';
import util from './util';

class supplierHelper {
    constructor() {
        if (!supplierHelper.instance) {
            supplierHelper.instance = this;
            supplierHelper.instance._mapData = [];
            supplierHelper.instance._groups = [];
            supplierHelper.instance._outsideHubs = [];
        }

        return supplierHelper.instance;
    }


    setmapData(data) {
        this._mapData = data;
    }

    setGroup(data) {
        this._groups = data;
    }

    getGroups() {
        return this._groups;
    }

    setOutsideHubs(data) {
        this._outsideHubs = data;
    }

    getOutsideHubs() {
        return this._outsideHubs;
    }

    //Master list of suppliers by State in alphabetical order including fields
    getSupplierListByStates = (data) => {
        let dataList = [];
        data.forEach(item => {
            let newItem = this.getNewItem(item);
            dataList.push(newItem);
        });

        const utilFunc = new util();
        dataList.sort(utilFunc.alphabeticSearch('State'));
        return dataList;
    }

    getStateListBySupplierCounts = (data) => {

        let objList = [];
        data?.forEach(function (item) {
            if (!item) return;

            let tmpStates = !item.state ? 'Unknown' : item.state;

            let projectIndex = objList.findIndex((e) => e.state === tmpStates);
            // Check the State exists in the Group. If not existing, add to Group or raise the count
            if (projectIndex == -1) {
                objList.push({
                    state: tmpStates,
                    count: 1
                });
            } else {
                objList[projectIndex].count++;
            }
        });

        const utilFunc = new util();
        objList.sort(utilFunc.getSortOrder('count'));

        return objList;
    };

    getMasterList = () => {
        let masterList = [];
        let excelGroupList = [];
        let excelOutsideHubList = [];
        this._groups.forEach((group) => {

            let groupData = [];
            group.data.forEach((item) => {
                let hubName;
                if (item.uuid === group.centralHub.uuid)
                    hubName = "Central Hub";
                else
                    hubName = group.centralHub.vendorNo;

                let newItem = this.getNewItem(item);
                newItem["Hub Name"] = hubName;
                newItem["Distance"] = item.distanceMile

                masterList.push(newItem)
                groupData.push(newItem);
            })

            excelGroupList.push({ data: groupData });
        });

        this._outsideHubs.forEach((item) => {
            let newItem = this.getNewItem(item);
            newItem["Hub Name"] = "Outside Hub";
            newItem["Distance"] = 0
            masterList.push(newItem)
            excelOutsideHubList.push(newItem);
        });

        const utilFunc = new util();
        masterList.sort(utilFunc.alphabeticSearch('State'));
        console.log(masterList);
        return [masterList, excelGroupList, excelOutsideHubList];
    }

    getNewItem = (item) => {
        return {
            "Vendor No": item.vendorNo,
            "State": item.state,
            "City": item.city,
            "Address": item.address,
            "Longtitude": item.longitude,
            "Latitude": item.latitude,
            "PlaceId": item.placeId
        };
    }
    getSummary = (data) => {
        let summaryList = {};
        let stateList = this.getStateListBySupplierCounts(data);

        summaryList.supplierCount = data.length;
        summaryList.stateCount = stateList.length;
        summaryList.stateList = stateList;
        summaryList.hubCount = this._groups.length + this._outsideHubs.length;
        summaryList.outsideHubCount = this._outsideHubs.length;

        console.log(this._groups);
        return summaryList;
    }
}

export default supplierHelper;
